import React, { useState } from 'react';

import { Button, Input } from '@copilot/ui';
import { Field } from '../common/Field';
import { Modal } from '@copilot/ui';
import * as companyApi from '../../services/companyApi';

// "Website" here maps to the existing Company.domain field (backend/
// schemas/company.py's CompanyCreate.domain) - no new backend field,
// just a more familiar label for what is already a plain optional
// string.
function CreateCompanyModal({ onClose, onCreated }) {
  const [name, setName] = useState('');
  const [website, setWebsite] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!name.trim()) {
      setError('Name is required.');
      return;
    }

    setError('');
    setIsSubmitting(true);

    try {
      const company = await companyApi.createCompany({
        name: name.trim(),
        domain: website.trim(),
      });
      onCreated(company);
    } catch (err) {
      setError(err.message || 'Unable to create related context.');
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      title="Create New Related Context"
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </>
      }
    >
      <form className="form-grid" onSubmit={handleSubmit}>
        <Field label="Name" htmlFor="company-name">
          <Input
            id="company-name"
            placeholder="Google"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            required
          />
        </Field>

        <Field label="Website (optional)" htmlFor="company-website">
          <Input
            id="company-website"
            placeholder="google.com"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
          />
        </Field>

        {error && <div className="form-alert">{error}</div>}
      </form>
    </Modal>
  );
}

export default CreateCompanyModal;
